import type { Segment as OldSegment } from "../../../types";
import type { Segment } from "../types";

export function mapOldSegmentToNewSegment(segment: OldSegment): Segment {
  const recipient_type_key =
    segment.conditions.find((c) => c.field.startsWith("recipient_type_"))?.field || "";

  return {
    id: segment.id,
    name: segment.name ?? "",
    description: segment.description ?? "",
    is_default: segment.is_default || false,
    is_recipient_type: segment.is_recipient_type,
    operation: segment.operation,
    segment_json: {
      type: "segment",
      operation: "OR" as const,
      segments: [
        {
          type: "segment_group" as const,
          operation: segment.operation,
          recipient_type_key,
          conditions: segment.conditions
            .filter((c) => c.field && c.operation && !c.field.startsWith("recipient_type_"))
            .map((c) => ({
              field: c.field,
              operation: c.operation,
              values: c.values,
              invert: c.invert,
            })),
        },
      ],
    },
  };
}
